/**
 * ArrayUtils class.
 */
class ArrayUtils {

    /**
     * Split an array into chunks of same size
     *
     * @param arr
     * @param size
     */
    public chunk<T>(arr: T[], size: number) : T[][] {
        const res : T[][] = [];

        for (let i = 0; i < arr.length; i += size) {
            const chunk : T[] = arr.slice(i, i + size);
            res.push(chunk);
        }

        return res;
    }
}

export default new ArrayUtils();
